export default __webpack_public_path__ + "static/media/5.45ca11a6.svg";